import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ErrorPage from "../commons/404"
import routes from "./routes";
import PrivateRoute from "./Private";
import PublicRoute from "./Public";

const Routes = () => {
  return (
    <Router>
      <Switch>
        {routes.map((route, i) => {
          if (route.auth) {
            return <PrivateRoute key={i} {...route} />;
          }
          return <PublicRoute key={i} {...route} />;
        })}
        <Route to={`/404`} exact component={ErrorPage} />
        <Route component={ErrorPage} />
      </Switch>
    </Router>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/index.js